// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"InvitePageWrapper-bec9fdd5f304bb02"};